export default __webpack_public_path__ + "static/media/299.cb2785b9.jpg";